import React from 'react';
import FeatureGameTable from '../../features/games/details/components/GameTable';

const GameTable: React.FC<React.ComponentProps<typeof FeatureGameTable>> = (props) => <FeatureGameTable {...props} />;

export default GameTable;
